import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { apiErrorMessage, apiFetch } from '@/lib/api'
import { SESSION_QUERY_KEY } from '@/lib/auth'
import Button from '@/components/ui/Button'

export default function RodoModal() {
  const qc = useQueryClient()
  const ack = useMutation({
    mutationFn: () =>
      apiFetch<{ ok: true }>('/api/auth/rodo-acknowledged', {
        method: 'POST',
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: SESSION_QUERY_KEY })
    },
    onError: (err) => {
      toast.error(apiErrorMessage(err))
    },
  })

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4 py-8 bg-bg-canvas/80 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="rodo-title"
    >
      <div className="w-full max-w-[520px] max-h-[90vh] overflow-y-auto rounded-card border border-border-subtle bg-bg-elevated p-6 sm:p-8">
        <h2 id="rodo-title" className="text-xl font-semibold mb-4">
          Informacja o przetwarzaniu danych osobowych
        </h2>
        <div className="space-y-3 text-sm leading-relaxed text-text-primary">
          <p>
            Administratorem Twoich danych jest{' '}
            <span className="font-medium">Dental Avenue</span>, ul. Kolejowa 45/U2,
            01-210 Warszawa.
          </p>

          <p>W ramach ewidencji czasu pracy zbieramy:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>czas rozpoczęcia i zakończenia Twojej pracy,</li>
            <li>
              lokalizację GPS w momencie kliknięcia „Zaczynam/Koniec pracy"
              (szerokość, długość, dokładność).
            </li>
          </ul>

          <p className="text-text-muted">
            <span className="font-medium text-text-primary">Podstawa prawna:</span>{' '}
            art. 6 ust. 1 lit. c i f RODO — obowiązek prawny pracodawcy w zakresie
            ewidencji czasu pracy (Kodeks pracy) oraz uzasadniony interes
            pracodawcy w weryfikacji obecności w miejscu pracy.
          </p>

          <p className="text-text-muted">
            <span className="font-medium text-text-primary">Retencja:</span> dane
            GPS przechowujemy przez 12 miesięcy, potem są anonimizowane. Czas
            pracy przechowujemy zgodnie z wymogami Kodeksu pracy.
          </p>

          <p className="text-text-muted">
            <span className="font-medium text-text-primary">Dostęp:</span> GPS
            widzi tylko administrator (manager kliniki). Twoje czasy pracy widzisz
            Ty i administrator.
          </p>

          <p className="text-text-muted">
            Masz prawo dostępu, sprostowania, ograniczenia przetwarzania i
            wniesienia sprzeciwu. Skargi: Prezes UODO.
          </p>
        </div>

        <div className="mt-6">
          <Button
            type="button"
            className="w-full"
            loading={ack.isPending}
            onClick={() => ack.mutate()}
          >
            Rozumiem
          </Button>
        </div>
      </div>
    </div>
  )
}
